module.exports = __webpack_public_path__ + "static/media/discord.0b10154d.svg";